"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.getUserColor = exports.generateUserColors = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _clientAuth = require("@devsta/client-auth"),
    _lodash = _interopRequireDefault(require("lodash.uniq")),
    _userColors = require("./constants/userColors");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var source, i = 1; i < arguments.length; i++) {
    source = null == arguments[i] ? {} : arguments[i], i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2["default"])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var generateUserColors = function generateUserColors(_ref) {
  var userIds = _ref.userIds,
      uniqueUserIds = (0, _lodash["default"])(userIds);
  return uniqueUserIds.reduce(function (colorMap, userId, userIndex) {
    var colorIndex = userIndex % _userColors.userColors.length,
        _userColors$colorInde = _userColors.userColors[colorIndex],
        color = _userColors$colorInde.color,
        darken = _userColors$colorInde.darken,
        lightenFactor = 30 * Math.floor(userIndex / _userColors.userColors.length);
    return _objectSpread({}, colorMap, (0, _defineProperty2["default"])({}, userId, {
      color: color,
      brightness: darken ? "brightness(".concat(100 - lightenFactor, "%)") : "brightness(".concat(100 + lightenFactor, "%)"),
      darken: darken
    }));
  }, {});
};

exports.generateUserColors = generateUserColors;

var getUserColor = function getUserColor(_ref2) {
  var _ref2$userAssignedCol = _ref2.userAssignedColors,
      userAssignedColors = void 0 === _ref2$userAssignedCol ? {} : _ref2$userAssignedCol,
      userId = _ref2.userId,
      currentCredentials = _clientAuth.credentials.get(),
      currentUserId = userId || currentCredentials.user.userId,
      userColor = userAssignedColors[currentUserId];

  if (userColor) return {
    userColor: userColor
  };
  var userIds = [].concat((0, _toConsumableArray2["default"])(Object.keys(userAssignedColors)), [currentUserId]),
      updatedUserColors = generateUserColors({
    userIds: userIds
  });
  return {
    userColor: updatedUserColors[currentUserId],
    updatedUserColors: updatedUserColors
  };
};

exports.getUserColor = getUserColor;